export default __webpack_public_path__ + "static/media/section-activity-illustration-manage-event.bab00e87.svg";